export enum RoutingFilterPermission {
  ALLOW = 'IS_ALLOWED',
  BLOCK = 'IS_BLOCKED'
}
